import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FiTrash2 } from "react-icons/fi";

export default function DeleteStudentModal({ show, onHide, onDelete }) {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Body
        style={{
          textAlign: "center",
          padding: "30px 20px",
        }}
      >
        {/* ICON BOX */}
        <div
          style={{
            width: 70,
            height: 70,
            margin: "0 auto",
            borderRadius: 10,
            background: "#fee2e2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <FiTrash2 size={28} color="#dc2626" />
        </div>

        {/* TITLE */}
        <h4
          style={{
            marginTop: 20,
            fontWeight: 600,
            color: "#1f2937",
          }}
        >
          Confirm Delete
        </h4>

        {/* TEXT */}
        <p
          style={{
            marginTop: 10,
            color: "#6b7280",
            fontSize: 14,
            lineHeight: 1.5,
          }}
        >
          You want to delete all the marked items, this can’t be undone once you delete.
        </p>

        {/* BUTTONS */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 12,
            marginTop: 20,
          }}
        >
          <Button
            onClick={onHide}
            style={{
              background: "#f3f4f6",
              border: "1px solid #e5e7eb",
              color: "#111",
              padding: "8px 18px",
              borderRadius: 8,
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={onDelete}
            style={{
              background: "#ef4444",
              border: "none",
              padding: "8px 18px",
              borderRadius: 8,
            }}
          >
            Yes, Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}